import { Box, CircularProgress, Grid2, Link, Typography } from '@mui/material';
import styled from '@emotion/styled';
import { useCurrentCompanyDetails } from '../../services/paymentsQuery';
import { TextMedium, XSMedium } from '../../typography/Typography';
import { t } from 'i18next';
import { DashboardCard } from './common';
import Chip from '../../components/shared/Chip';
import { textTransform } from '@mui/system';
import { useUser } from '@/contexts/user/UserContext';
import { UserRoles } from '@/models/company';

const BalanceList = styled('div')`
    display: flex;
    justify-content: space-between;
`;

const MutedText = styled(Typography)`
    font-family: 'Inter', sans-serif;
    font-weight: 400;
    font-size: 14px;
    line-height: 100%;
    letter-spacing: 0;
    color: #667085;
`;

const MutedTextBold = styled(Typography)`
    font-family: 'Inter', sans-serif;
    font-weight: 700;
    font-size: 14px;
    line-height: 100%;
    letter-spacing: 0;
    color: #667085;
`;

export const TopUpAccount = () => {
    const { data, isPending } = useCurrentCompanyDetails();
    const { user } = useUser();
    const isManager = user?.role === UserRoles.Manager;

    return (
        <Grid2 size={{ xs: 12, sm: 12, md: 12, lg: 3.8 }}>
            <DashboardCard>
                {isPending && (
                    <Box mt={2} mr={10}>
                        <CircularProgress size={20} />
                    </Box>
                )}
                {!isPending && (
                    <>
                        <Box
                            display={'flex'}
                            justifyContent={'space-between'}
                            alignItems={'center'}
                            mb={1}
                        >
                            <TextMedium textAlign={'left'}>
                                {t('topup_your_account')}
                            </TextMedium>
                            <Link
                                sx={{
                                    textTransform: 'none',
                                    pointerEvents: isManager
                                        ? 'none'
                                        : undefined
                                }}
                                href={
                                    isManager
                                        ? undefined
                                        : 'settings/payment_settings'
                                }
                                underline="none"
                            >
                                {data?.data?.autoTopupStatus ===
                                    'Connected' && (
                                    <>
                                        {data?.data?.autoTopupEnabled ? (
                                            <Chip
                                                icon={<span></span>}
                                                label={
                                                    <XSMedium>
                                                        {t(
                                                            'auto_topup_enabled'
                                                        )}
                                                    </XSMedium>
                                                }
                                                color="success"
                                            />
                                        ) : (
                                            <Chip
                                                icon={<span></span>}
                                                label={
                                                    <XSMedium>
                                                        {t('auto_topup_paused')}
                                                    </XSMedium>
                                                }
                                                color="warning"
                                            />
                                        )}
                                    </>
                                )}
                            </Link>
                        </Box>
                        <Box mt={1} sx={{ clear: 'both' }}>
                            <MutedText>
                                {t('transfer_to_instaPaid_at_danske_bank')}
                            </MutedText>
                            <Box display={'flex'} flexDirection={'row'}>
                                <MutedText>{t('reg_no')}</MutedText>{' '}
                                <MutedTextBold>
                                    {/* {data?.data?.regNo} */}
                                    3409
                                </MutedTextBold>
                            </Box>
                            <Box display={'flex'} flexDirection={'row'}>
                                <MutedText>{t('account_no')}</MutedText>{' '}
                                <MutedTextBold>
                                    {/* {data?.data?.accountNo} */}
                                    13721076
                                </MutedTextBold>
                            </Box>

                            <Box display={'flex'}>
                                <MutedText>
                                    {t('bank_trasfer_reference')}{' '}
                                </MutedText>
                                <MutedTextBold>
                                    {data?.data?.customerId}
                                </MutedTextBold>
                            </Box>
                        </Box>
                    </>
                )}
            </DashboardCard>
        </Grid2>
    );
};
